export default __webpack_public_path__ + "static/media/logo.ebcc3d72.svg";